import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectCard = ({ project, isFeatured = false }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case 'En Venta':
        return 'bg-success text-success-foreground';
      case 'Próximamente':
        return 'bg-warning text-warning-foreground';
      case 'Agotado':
        return 'bg-muted text-muted-foreground';
      default:
        return 'bg-primary text-primary-foreground';
    }
  };

  const handleViewDetails = () => {
    if (project?.id === 'residencial-3-volcanes') {
      navigate('/interactive-floor-plans');
    }
  };

  return (
    <div
      className={`
        card overflow-hidden transition-smooth hover:elevation-4
        ${isFeatured ? 'border-2 border-primary' : ''}
      `}
    >
      {isFeatured && (
        <div className="absolute top-4 right-4 z-10 bg-primary text-primary-foreground px-4 py-2 rounded-lg font-medium text-sm">
          Proyecto Destacado
        </div>
      )}
      <div className="relative w-full h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={project?.image}
          alt={project?.imageAlt}
          className="w-full h-full object-cover transition-smooth hover:scale-105"
        />
        <div className={`absolute top-4 left-4 ${getStatusColor(project?.status)} px-4 py-2 rounded-lg font-medium text-sm`}>
          {project?.status}
        </div>
      </div>
      <div className="p-6 md:p-8">
        <h3 className="text-2xl md:text-3xl font-semibold text-foreground mb-2 line-clamp-2">
          {project?.name}
        </h3>

        <div className="flex items-center text-muted-foreground mb-4">
          <Icon name="MapPin" size={18} className="mr-2 flex-shrink-0" />
          <span className="text-sm md:text-base line-clamp-1">{project?.location}</span>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="bg-muted rounded-lg p-4">
            <div className="flex items-center mb-2">
              <Icon name="Home" size={20} color="var(--color-primary)" className="mr-2" />
              <span className="text-xs md:text-sm text-muted-foreground">Total Lotes</span>
            </div>
            <p className="text-xl md:text-2xl font-semibold text-foreground data-text">
              {project?.totalLots}
            </p>
          </div>

          <div className="bg-muted rounded-lg p-4">
            <div className="flex items-center mb-2">
              <Icon name="CheckCircle2" size={20} color="var(--color-success)" className="mr-2" />
              <span className="text-xs md:text-sm text-muted-foreground">Disponibles</span>
            </div>
            <p className="text-xl md:text-2xl font-semibold text-foreground data-text">
              {project?.availableLots}
            </p>
          </div>
        </div>

        <div className="mb-6">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm md:text-base text-muted-foreground">Rango de Precios</span>
            <span className="text-lg md:text-xl font-semibold text-primary data-text">
              {project?.priceRange}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm md:text-base text-muted-foreground">Entrega Estimada</span>
            <span className="text-base md:text-lg font-medium text-foreground">
              {project?.completionDate}
            </span>
          </div>
        </div>

        {project?.features && project?.features?.length > 0 && (
          <div className="mb-6">
            <div className="flex flex-wrap gap-2">
              {project?.features?.map((feature, index) => (
                <span
                  key={index}
                  className="inline-flex items-center bg-accent/10 text-accent px-3 py-1 rounded-lg text-xs md:text-sm"
                >
                  <Icon name="Check" size={14} className="mr-1" />
                  {feature}
                </span>
              ))}
            </div>
          </div>
        )}

        <Button
          variant="default"
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
          onClick={handleViewDetails}
          disabled={project?.status === 'Agotado'}
        >
          {project?.status === 'Agotado' ? 'Proyecto Agotado' : 'Ver Detalles'}
        </Button>
      </div>
    </div>
  );
};

export default ProjectCard;